import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface SectionHeadingProps {
    id: string
    title: string | null
    body?: string | null
    className?: string
    inverted?: boolean
}

const SectionHeading: FC<SectionHeadingProps> = ({ id, title, body, className, inverted }): ReactNode => {
    if (!title && !body) return null

    return (
        <div className={cn('mx-auto max-w-2xl text-center', className)}>
            {title && (
                <h2
                    id={id}
                    className={cn(
                        'font-heading text-4xl leading-tight tracking-tight text-balance sm:text-5xl',
                        inverted ? 'text-primary-foreground' : 'text-foreground'
                    )}
                >
                    {title}
                </h2>
            )}

            {body && (
                <p className={cn('mt-4 text-lg leading-relaxed text-pretty', inverted ? 'text-primary-foreground/80' : 'text-muted-foreground')}>
                    {body}
                </p>
            )}
        </div>
    )
}

export default SectionHeading
